import React, {useEffect} from 'react';

const WebPushScript = ({activeWidget}) => {
    useEffect(() => {
        const scriptEl = document.createElement('script');
        scriptEl.src = 'https://sdk.justpush.ai/js/v0/webpush.js';
        scriptEl.async = true;
        scriptEl.addEventListener('load', function () {
            const initConfig = {
                projectId: 'e5851816-8bf6-4c2a-a266-272c91379daa',
                subscribeOnPageLoad: true,
                subscribeOnPageLoadDelay: 2000,
                workerPath: "/sw.js",
                widgets: {
                    showRobot: activeWidget === 'robot',
                    robotProps: {
                        position: 'top-center',
                        skipText: 'Пропустить',
                        text: 'Нажмите значок замка в адресной строке, чтобы разрешить уведомления.',
                        title: 'Пожалуйста, включите доступ к получению push-уведомлений',
                    },
                    showDialog: activeWidget === 'dialog',
                    dialogProps: {
                        position: 'top-center',
                        title: 'Получайте push-уведомления о последних обновлениях',
                        text: '',
                        cancelText: 'Отменить',
                        confirmText: 'Подписаться',
                        delay: 300,
                    },
                    showBubble: activeWidget === 'bubble',
                    bubbleProps: {
                        text: 'Вам новое сообщение',
                        delay: 300,
                    },
                    showCaptcha: activeWidget === 'captcha',
                    showToast: false,
                    toastProps: {
                        position: 'top-right',
                        text: '',
                        skipText: 'Пропустить',
                        title: 'Вы успешно подписались на получение push-уведомлений',
                    },
                },
                onSuccessCallback: function () {
                    console.log('Subscription was successful');
                }, // Успешная подписка
                onFailedCallback: function () {
                    console.log('Subscription failed');
                }, // Неудачная подписка
                onDeniedCallback: function () {
                    console.log('Subscription was denied');
                }, // Отказ в подписке
                onSubscribedCallback: function () {
                    console.log('Subscription was saved on server');
                },
            }
            ytrgt.webpush.init(initConfig);
        });

        document.body.append(scriptEl);

        return () => {
            document.body.removeChild(scriptEl);
        };
    }, [activeWidget]);

    return null;
};

export default WebPushScript;
